export default "__VITE_ASSET__Xi4wM481__"